import XDC3 from "xdc3";

window.web3 = new XDC3(window.xdc);
const xdc3 = new XDC3(window.xdc);

export default xdc3;